module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoices":"Invoices","forProperty":"for property"},"sl":{"invoices":"Računi","forProperty":"nastanitve"}}')
  delete Component.options._Ctor
}
